import { render, staticRenderFns } from "./Superviseurs.vue?vue&type=template&id=4b5df780"
import script from "./Superviseurs.vue?vue&type=script&lang=js"
export * from "./Superviseurs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports